export default "__VITE_ASSET__CVqaiAM7__"